import { QueryKey } from '@/configs/queryKeys';
import {
	ComponentVariation,
	ComponentVariationArticle,
} from './ComponentVariationApi';
import { SerializedCreator } from '@/types/creator';
import { Attachment, UUID } from '@/types/types';
import { MontageType, ProductType } from './ProductTypeApi';
import { Color } from './ColorApi';
import { InvestmentItem } from './InvestmentItemApi';
import { Investment } from './InvestmentApi';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export type SelectedMontageType = Exclude<MontageType, MontageType.BOTH>;

export interface ConfigurationArticle {
	id?: UUID;
	code: string;
	componentVariationArticle: ComponentVariationArticle;
	componentVariationArticleId: UUID;
	color: Color | null;
	colorId: UUID | null;
	quantity: number;
}

export interface Project extends BaseEntity {
	number: string;
	investment?: Investment;
	investmentItem?: InvestmentItem;
	investmentItemId: UUID;
	componentVariations: ComponentVariation[];
	configurationArticles: ConfigurationArticle[];
	quantity: number;
	productType: Partial<ProductType>;
	productTypeId: UUID;
	description: string;
	selectedMontageType: SelectedMontageType;
	serializedCreator: SerializedCreator;
	image?: Attachment;
}

class ProjectApi extends EntityApi<Project> {
	constructor() {
		super(QueryKey.projects);
		this.copy = this.copy.bind(this);
		this.createVersion = this.createVersion.bind(this);
	}

	async copy(id: UUID) {
		const response = await httpClient.post<Project>(
			`${this.queryKey}/${id}/copy`
		);

		return response.data;
	}

	async createVersion(payload: Partial<Project>) {
		const response = await httpClient.post<Project>(
			`${this.queryKey}/version`,
			payload
		);

		return response.data;
	}
}

export default new ProjectApi();
